(function () {
  var citySyncTimer = null;

  function markCityFilterReady() {
    document.documentElement.classList.remove('sc-city-filter-pending');
    document.documentElement.classList.add('sc-city-filter-ready');
  }

  function parseMap(el) {
    try {
      return JSON.parse(el.getAttribute('data-city-availability') || '[]');
    } catch (e) {
      return [];
    }
  }

  function getVariantId(variant) {
    if (!variant) return '';
    return String(variant.variant_id || variant.id || '');
  }

  function getVariantQty(variant) {
    if (!variant) return null;

    var possibleQty = null;

    if (variant.inventory_quantity !== undefined && variant.inventory_quantity !== null && variant.inventory_quantity !== '') {
      possibleQty = variant.inventory_quantity;
    } else if (variant.quantity !== undefined && variant.quantity !== null && variant.quantity !== '') {
      possibleQty = variant.quantity;
    } else if (variant.qty !== undefined && variant.qty !== null && variant.qty !== '') {
      possibleQty = variant.qty;
    } else if (variant.max_qty !== undefined && variant.max_qty !== null && variant.max_qty !== '') {
      possibleQty = variant.max_qty;
    }

    if (possibleQty === null) return null;

    var qty = parseInt(possibleQty, 10);
    return Number.isNaN(qty) ? null : qty;
  }

  function isVariantActuallyAvailable(variant) {
    if (!variant) return false;

    if (variant.available === false || variant.available === 'false') {
      return false;
    }

    var qty = getVariantQty(variant);

    if (qty !== null && qty <= 0) {
      return false;
    }

    return true;
  }

  function getVariantMaxQty(variant) {
    var qty = getVariantQty(variant);

    if (qty !== null) {
      return Math.max(qty, 0);
    }

    return 9999;
  }

  function findCityVariant(map, city) {
    if (!map || !city || !window.CityState) return null;

    var variantCity = window.CityState.getVariantCity(city);
    if (!variantCity) return null;

    return map.find(function (item) {
      return String(item.city || '').toLowerCase() === String(variantCity).toLowerCase();
    }) || null;
  }

  function setAttr(el, name, value) {
    if (!el) return;

    value = String(value);

    if (el.getAttribute(name) !== value) {
      el.setAttribute(name, value);
    }
  }

  function removeAttr(el, name) {
    if (!el) return;

    if (el.hasAttribute(name)) {
      el.removeAttribute(name);
    }
  }

  function setText(el, text) {
    if (!el || text === undefined || text === null) return;

    text = String(text);

    if (el.textContent !== text) {
      el.textContent = text;
    }
  }

  function addClass(el, className) {
    if (el && !el.classList.contains(className)) {
      el.classList.add(className);
    }
  }

  function removeClass(el, className) {
    if (el && el.classList.contains(className)) {
      el.classList.remove(className);
    }
  }

  function hideCard(card) {
    if (!card) return;

    card.style.display = 'none';
    setAttr(card, 'data-city-hidden', 'true');
    setAttr(card, 'data-current-city-variant-available', 'false');

    var cardAtc = card.querySelector('.sc-card-atc');

    if (cardAtc) {
      addClass(cardAtc, 'sc-card-atc--soldout');
      setAttr(cardAtc, 'aria-disabled', 'true');

      cardAtc.querySelectorAll('button').forEach(function (button) {
        setAttr(button, 'disabled', 'disabled');
        addClass(button, 'is-disabled');
      });
    }
  }

  function showCard(card) {
    if (!card) return;

    card.style.display = '';
    removeAttr(card, 'data-city-hidden');
  }

  function parseMoneyToCents(value) {
  if (value === undefined || value === null || value === '') return null;

  /*
    Shopify numeric prices are usually in cents:
    4999 = 49.99
    If somehow amount is already decimal:
    49.99 = 49.99
  */
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return null;

    if (value > 999) {
      return Math.round(value);
    }

    return Math.round(value * 100);
  }

  var raw = String(value).trim();

  if (!raw || raw === 'null' || raw === 'undefined' || raw === 'false') {
    return null;
  }

  raw = raw
    .replace(/SAR/gi, '')
    .replace(/SR/gi, '')
    .replace(/ر\.س/g, '')
    .replace(/ريال/g, '')
    .replace(/[^\d.,]/g, '')
    .replace(',', '.')
    .trim();

  if (!raw) return null;

  var amount = parseFloat(raw);

  if (!Number.isFinite(amount)) return null;

  return Math.round(amount * 100);
}

function formatCentsToMoney(cents) {
  if (cents === undefined || cents === null || !Number.isFinite(cents)) return '';

  var amount = cents / 100;
  return amount.toFixed(2) + ' SR';
}

function isVariantOnSale(variant) {
  if (!variant) return false;

  var priceCents = parseMoneyToCents(variant.price);
  var compareCents = parseMoneyToCents(variant.compare_at_price);

  if (priceCents === null || compareCents === null) return false;

  return compareCents > priceCents;
}

function getVariantDiscountPercent(variant) {
  if (!isVariantOnSale(variant)) return 0;

  var priceCents = parseMoneyToCents(variant.price);
  var compareCents = parseMoneyToCents(variant.compare_at_price);

  if (!priceCents || !compareCents || compareCents <= priceCents) return 0;

  var discount = Math.round(((compareCents - priceCents) * 100) / compareCents);

  if (!Number.isFinite(discount) || discount <= 0) return 0;

  return discount;
}

function updateCitySaleBadge(card, variant) {
  if (!card) return;

  var badge = card.querySelector('[data-city-sale-badge]');
  if (!badge) return;

  var discount = getVariantDiscountPercent(variant);

  if (!discount) {
    badge.textContent = '';
    addClass(badge, 'is-hidden');
    return;
  }

  badge.textContent = '-' + discount + '%';
  removeClass(badge, 'is-hidden');
}

function renderCityFormattedPriceFromCents(cents) {
  if (cents === null || cents === undefined || !Number.isFinite(cents)) {
    return '';
  }

  return '<span data-city-price>' + formatCentsToMoney(cents) + '</span>';
}

function updatePrice(card, variant) {
  if (!card || !variant) return;

  var priceBox = card.querySelector('.t4s-product-price');
  if (!priceBox) return;

  var priceCents = parseMoneyToCents(variant.price);
  var compareCents = parseMoneyToCents(variant.compare_at_price);
  var onSale = isVariantOnSale(variant);

  if (priceCents === null) return;

  if (onSale) {
    priceBox.innerHTML =
      '<del data-city-compare-price>' + formatCentsToMoney(compareCents) + '</del>' +
      '<ins><span data-city-price>' + formatCentsToMoney(priceCents) + '</span></ins>';

    addClass(priceBox, 'is-city-on-sale');
  } else {
    priceBox.innerHTML =
      '<span data-city-price>' + formatCentsToMoney(priceCents) + '</span>';

    removeClass(priceBox, 'is-city-on-sale');
  }

  updateCitySaleBadge(card, variant);
}

  function updateLowStockBadge(card, variant) {
  if (!card) return;

  var badgesWrap = card.querySelector('[data-card-badges]');
  if (!badgesWrap) return;

  var threshold = parseInt(badgesWrap.getAttribute('data-low-stock-threshold') || '15', 10);
  var criticalThreshold = 5; // Qty 1–4 will show "Only X left"

  var lowStockLabel = badgesWrap.getAttribute('data-low-stock-label') ||
    (document.documentElement.lang && document.documentElement.lang.indexOf('ar') === 0 ? 'ينفد بسرعة' : 'Selling Fast');

  var slot2 = badgesWrap.querySelector('[data-badge-slot="2"]');
  if (!slot2) return;

  var defaultLabel = slot2.getAttribute('data-default-label') || '';
  var qty = getVariantQty(variant);

  var isArabic =
    (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0 ||
    (document.documentElement.dir || '').toLowerCase() === 'rtl';

  var shouldShowLowStock =
    variant &&
    isVariantActuallyAvailable(variant) &&
    qty !== null &&
    qty > 0 &&
    qty < threshold;

  slot2.classList.remove('is-critical-low-stock');
  slot2.classList.remove('is-low-stock');

  if (shouldShowLowStock) {
    if (qty < criticalThreshold) {
      setText(
        slot2,
        isArabic ? 'باقي ' + qty + ' فقط' : 'Only ' + qty + ' left'
      );

      removeClass(slot2, 'is-hidden');
      addClass(slot2, 'is-low-stock');
      addClass(slot2, 'is-critical-low-stock');
      return;
    }

    setText(slot2, lowStockLabel);
    removeClass(slot2, 'is-hidden');
    addClass(slot2, 'is-low-stock');
    return;
  }

  setText(slot2, defaultLabel);

  if (defaultLabel.trim() === '') {
    addClass(slot2, 'is-hidden');
  } else {
    removeClass(slot2, 'is-hidden');
  }
}

  function showSoldOut(card) {
    if (!card) return;

    addClass(card, 'is-city-soldout');
    removeAttr(card, 'data-city-hidden');
    setAttr(card, 'data-current-city-variant-available', 'false');

    var badge = card.querySelector('[data-city-soldout]');
    if (badge) badge.hidden = false;

    var addBtn = card.querySelector('[data-city-add-to-cart]');

    if (addBtn) {
      setAttr(addBtn, 'disabled', 'disabled');
      addClass(addBtn, 'is-disabled');
      setText(addBtn, addBtn.getAttribute('data-soldout-label') || 'Sold out');
    }

    var cardAtc = card.querySelector('.sc-card-atc');

    if (cardAtc) {
      addClass(cardAtc, 'sc-card-atc--soldout');
      setAttr(cardAtc, 'aria-disabled', 'true');

      cardAtc.querySelectorAll('button').forEach(function (button) {
        setAttr(button, 'disabled', 'disabled');
        addClass(button, 'is-disabled');
      });
    }

    updateLowStockBadge(card, null);
  }

  function updateCardVariant(card, variant) {
    if (!card || !variant) return false;

    var variantId = getVariantId(variant);
    var available = isVariantActuallyAvailable(variant);
    var maxQty = getVariantMaxQty(variant);

    if (!variantId || !available) {
      return false;
    }

    showCard(card);
    removeClass(card, 'is-city-soldout');

    setAttr(card, 'data-current-city-variant-id', variantId);
    setAttr(card, 'data-current-city-variant-available', 'true');
    setAttr(card, 'data-current-city-variant-max', String(maxQty));

    var productOptionsAttr = card.getAttribute('data-product-options');

    if (productOptionsAttr) {
      try {
        var productOptions = JSON.parse(productOptionsAttr);
productOptions.VariantFirstID = variantId;
productOptions.maxQuantity = maxQty;
productOptions.available = true;
productOptions.price = variant.price || 0;
productOptions.compare_at_price = variant.compare_at_price || null;
setAttr(card, 'data-product-options', JSON.stringify(productOptions));
      } catch (e) {}
    }

    var cardAtc = card.querySelector('.sc-card-atc');

    if (cardAtc) {
      setAttr(cardAtc, 'data-variant-id', variantId);
      setAttr(cardAtc, 'data-max', String(maxQty));
      removeClass(cardAtc, 'sc-card-atc--soldout');
      removeClass(cardAtc, 'sc-card-atc--city-pending');
      removeAttr(cardAtc, 'aria-disabled');

      cardAtc.querySelectorAll('button').forEach(function (button) {
        removeAttr(button, 'disabled');
        removeClass(button, 'is-disabled');
      });
    }

    var notifyBtn = card.querySelector('[data-notify-stock-btn]');

    if (notifyBtn) {
      setAttr(notifyBtn, 'data-variant-id', variantId);
    }

    card.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (input) {
      if (input.value !== variantId) {
        input.value = variantId;
      }
    });

    updateLowStockBadge(card, variant);
    updatePrice(card, variant);

    return true;
  }

  function processCards() {
    try {
      if (!window.CityState) {
        markCityFilterReady();
        return;
      }

      var city = window.CityState.get();

      if (!city) {
        markCityFilterReady();
        return;
      }

      document.querySelectorAll('[data-city-availability]').forEach(function (card) {
        if (card.hasAttribute('data-city-pdp-root')) return;

        var mode = card.getAttribute('data-city-mode') || 'hide';
        var map = parseMap(card);
        var cityVariant = findCityVariant(map, city);

        if (!isVariantActuallyAvailable(cityVariant)) {
          updateLowStockBadge(card, null);

          if (mode === 'soldout') {
            showSoldOut(card);
          } else {
            hideCard(card);
          }

          return;
        }

        updateCardVariant(card, cityVariant);
      });

      markCityFilterReady();
    } catch (e) {
      markCityFilterReady();
    }
  }

  function setButtonText(button, text) {
    if (!button || !text) return;

    var textEl =
      button.querySelector('[data-city-pdp-atc-text]') ||
      button.querySelector('.t4s-btn-atc_text') ||
      button.querySelector('.t4s-text-pr') ||
      button.querySelector('[data-atc-text]') ||
      button.querySelector('.product-form__submit-text') ||
      button.querySelector('.t4s-product-form__submit-text') ||
      button.querySelector('span');

    if (textEl) {
      setText(textEl, text);
      return;
    }

    if (button.tagName === 'BUTTON' || button.tagName === 'A') {
      setText(button, text);
    }
  }

  function updatePdpStockStatus(root, available) {
    var stockAreas = [];

    if (root) {
      root.querySelectorAll('[data-product-available]').forEach(function (el) {
        stockAreas.push(el);
      });
    }

    stockAreas.forEach(function (wrap) {
      var availableStatus = wrap.querySelector('[data-available-status]');
      var instockStatus = wrap.querySelector('[data-instock-status]');
      var preorderStatus = wrap.querySelector('[data-preorder-status]');
      var soldoutStatus = wrap.querySelector('[data-soldout-status]');

      if (available) {
        if (availableStatus) {
          removeClass(availableStatus, 't4s-dn');
          availableStatus.style.display = '';
        }

        if (instockStatus) {
          removeClass(instockStatus, 't4s-dn');
          instockStatus.style.display = '';
        }

        if (preorderStatus) {
          addClass(preorderStatus, 't4s-dn');
          preorderStatus.style.display = 'none';
        }

        if (soldoutStatus) {
          addClass(soldoutStatus, 't4s-dn');
          soldoutStatus.style.display = 'none';
        }
      } else {
        if (availableStatus) {
          addClass(availableStatus, 't4s-dn');
          availableStatus.style.display = 'none';
        }

        if (instockStatus) {
          addClass(instockStatus, 't4s-dn');
          instockStatus.style.display = 'none';
        }

        if (preorderStatus) {
          addClass(preorderStatus, 't4s-dn');
          preorderStatus.style.display = 'none';
        }

        if (soldoutStatus) {
          removeClass(soldoutStatus, 't4s-dn');
          soldoutStatus.style.display = '';
        }
      }
    });
  }

  function updatePdpInventoryData(root, variantId, maxQty) {
    if (!root) return;

    root.querySelectorAll('[data-inventory-qty]').forEach(function (inventoryEl) {
      try {
        var data = JSON.parse(inventoryEl.getAttribute('data-inventory-qty') || '{}');
        data.inventoryQty = maxQty;
        data.id = variantId;
        setAttr(inventoryEl, 'data-inventory-qty', JSON.stringify(data));
      } catch (e) {}
    });
  }

  function updatePdpPickup(root, variantId) {
    if (!root) return;

    root.querySelectorAll('[data-pickup-availability-container]').forEach(function (pickup) {
      setAttr(pickup, 'data-variant-id', variantId);
    });
  }

  function updatePdpForms(root, variantId, available, maxQty) {
    if (!root) return;

    root.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (input) {
      if (input.value !== variantId) {
        input.value = variantId;
      }
    });

    root.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      setAttr(form, 'data-current-city-variant-id', variantId);
      setAttr(form, 'data-current-city-variant-available', available ? 'true' : 'false');
      setAttr(form, 'data-current-city-variant-max', String(maxQty));

      if (available) {
        removeClass(form, 'sc-city-pdp-soldout');
        form.removeAttribute('data-city-soldout');
      } else {
        addClass(form, 'sc-city-pdp-soldout');
        form.setAttribute('data-city-soldout', 'true');
      }

      form.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (input) {
        if (input.value !== variantId) {
          input.value = variantId;
        }
      });
    });
  }

  function updateCustomPdpAtc(root, variantId, available, maxQty) {
    if (!root) return;

    var addLabel = root.getAttribute('data-city-add-label') || 'Add to cart';
    var soldoutLabel = root.getAttribute('data-city-soldout-label') || 'Out of stock';

    var customWraps = [];

    root.querySelectorAll('[data-sc-pdp-sticky-mini-atc], [data-city-pdp-custom-atc-wrap], .sc-pdp-sticky-mini-atc').forEach(function (wrap) {
      customWraps.push(wrap);
    });

    document.querySelectorAll('[data-sc-pdp-sticky-mini-atc], [data-city-pdp-custom-atc-wrap], .sc-pdp-sticky-mini-atc').forEach(function (wrap) {
      if (customWraps.indexOf(wrap) === -1) {
        customWraps.push(wrap);
      }
    });

    customWraps.forEach(function (wrap) {
      setAttr(wrap, 'data-variant-id', variantId);
      setAttr(wrap, 'data-current-city-variant-id', variantId);
      setAttr(wrap, 'data-current-city-variant-available', available ? 'true' : 'false');

      if (typeof maxQty !== 'undefined') {
        setAttr(wrap, 'data-max', String(maxQty));
      }

      var input = wrap.querySelector('[data-city-card-variant-input], input[name="id"], select[name="id"]');
      if (input && input.value !== variantId) {
        input.value = variantId;
      }

      if (available) {
        removeClass(wrap, 'is-disabled');
        removeClass(wrap, 'sc-city-pdp-soldout');
      } else {
        addClass(wrap, 'is-disabled');
        addClass(wrap, 'sc-city-pdp-soldout');
      }

      var buttons = wrap.querySelectorAll('.sc-pdp-sticky-mini-atc__add, [data-city-pdp-atc]');

      buttons.forEach(function (button) {
        setAttr(button, 'data-variant-id', variantId);

        if (available) {
          removeAttr(button, 'disabled');
          removeAttr(button, 'aria-disabled');
          removeClass(button, 'is-disabled');
          removeClass(button, 'is--disabled');

          button.style.pointerEvents = '';
          button.style.opacity = '';
          button.style.cursor = '';

          setButtonText(button, addLabel);
        } else {
          setAttr(button, 'disabled', 'disabled');
          setAttr(button, 'aria-disabled', 'true');
          addClass(button, 'is-disabled');
          addClass(button, 'is--disabled');

          button.style.pointerEvents = 'none';
          button.style.opacity = '0.55';
          button.style.cursor = 'not-allowed';

          setButtonText(button, soldoutLabel);
        }
      });
    });

    if (window.scMiniAtcSyncFromCart) {
      window.clearTimeout(window.__scCityPdpAtcSyncTimer);
      window.__scCityPdpAtcSyncTimer = window.setTimeout(function () {
        window.scMiniAtcSyncFromCart();
      }, 120);
    }
  }

  function updateKallesPdpButtons(root, variantId, available) {
    if (!root) return;

    var addLabel = root.getAttribute('data-city-add-label') || 'Add to cart';
    var soldoutLabel = root.getAttribute('data-city-soldout-label') || 'Out of stock';

    var selectors = [
      '[data-action-atc]',
      '[data-atc-selector]',
      'button[name="add"]',
      '.t4s-pr-addtocart',
      '.t4s-product-form__submit',
      '.product-form__submit',
      '.shopify-payment-button__button',
      '.t4s-sticky-atc__atc'
    ].join(',');

    var buttons = [];

    root.querySelectorAll(selectors).forEach(function (button) {
      buttons.push(button);
    });

    document.querySelectorAll('.t4s-sticky-atc__atc, .t4s-pr-addtocart').forEach(function (button) {
      if (buttons.indexOf(button) === -1) {
        buttons.push(button);
      }
    });

    buttons.forEach(function (button) {
      setAttr(button, 'data-variant-id', variantId);

      if (available) {
        removeAttr(button, 'disabled');
        removeAttr(button, 'aria-disabled');
        removeClass(button, 'is-disabled');
        removeClass(button, 'is--disabled');
        removeClass(button, 't4s-btn-loading');

        button.style.pointerEvents = '';
        button.style.opacity = '';
        button.style.cursor = '';

        setButtonText(button, addLabel);
      } else {
        setAttr(button, 'disabled', 'disabled');
        setAttr(button, 'aria-disabled', 'true');
        addClass(button, 'is-disabled');
        addClass(button, 'is--disabled');
        removeClass(button, 't4s-btn-loading');

        button.style.pointerEvents = 'none';
        button.style.opacity = '0.55';
        button.style.cursor = 'not-allowed';

        setButtonText(button, soldoutLabel);
      }
    });
  }

  function updatePdpStockUrgency(root, cityVariant, city) {
  var el =
    (root && root.querySelector('[data-sc-pdp-stock-urgency]')) ||
    document.querySelector('[data-sc-pdp-stock-urgency]');

  if (!el) return;

  var textEl = el.querySelector('.sc-pdp-stock-urgency__text');
  var barFill = el.querySelector('.sc-pdp-stock-urgency__bar-fill');

  if (!textEl) return;

  el.classList.remove('sc-pdp-stock-urgency--low-stock');
  el.classList.remove('sc-pdp-stock-urgency--selling-fast');

  if (!cityVariant) {
    el.classList.add('is-hidden');
    textEl.textContent = '';
    el.style.removeProperty('--sc-stock-bar-width');
    return;
  }

  var normalLowStockThreshold = Number(el.getAttribute('data-low-stock-threshold') || '15');
  var criticalLowStockThreshold = 5;

  var qty = getVariantQty(cityVariant);
  var available = isVariantActuallyAvailable(cityVariant);

  var isArabic =
    (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0 ||
    (document.documentElement.dir || '').toLowerCase() === 'rtl';

  var cityTranslationsAr = {
    jeddah: 'جدة',
    riyadh: 'الرياض',
    dammam: 'الدمام',
    makkah: 'مكة',
    taif: 'الطائف',
    madinah: 'المدينة',
    medina: 'المدينة',
    al_hasa: 'الأحساء',
    alhasa: 'الأحساء',
    hofuf: 'الهفوف',
    jubail: 'الجبيل',
    yanbu: 'ينبع',
    buraidah: 'بريدة',
    al_kharj: 'الخرج',
    alkharj: 'الخرج',
    abha: 'أبها',
    jizan: 'جازان',
    tabuk: 'تبوك'
  };

  var normalizedCity = String(city || '')
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/-/g, '_');

  var cityLabel = '';

  if (isArabic && cityTranslationsAr[normalizedCity]) {
    cityLabel = cityTranslationsAr[normalizedCity];
  }

  if (!cityLabel && window.CityState && typeof window.CityState.getLabel === 'function') {
    cityLabel = window.CityState.getLabel(city) || '';
  }

  if (!cityLabel) {
    cityLabel = String(city || '').replace(/_/g, ' ');
    cityLabel = cityLabel.replace(/\b\w/g, function (m) {
      return m.toUpperCase();
    });
  }

  el.setAttribute('data-current-qty', qty !== null ? String(qty) : '0');
  el.setAttribute('data-variant-id', getVariantId(cityVariant));

  /*
    Out of stock:
    Hide urgency badge. Out-of-stock / BIS logic handles this.
  */
  if (!available || qty === null || qty <= 0) {
    el.classList.add('is-hidden');
    textEl.textContent = '';
    el.style.removeProperty('--sc-stock-bar-width');
    return;
  }

  /*
    Critical low stock:
    Qty 1–4 = show exact quantity + animated bar.
  */
  if (qty > 0 && qty < criticalLowStockThreshold) {
    textEl.textContent = isArabic
      ? 'باقي ' + qty + ' فقط'
      : 'Only ' + qty + ' left';

    var percent = Math.max(
      16,
      Math.min(100, (qty / criticalLowStockThreshold) * 100)
    );

    el.style.setProperty('--sc-stock-bar-width', percent + '%');

    if (barFill) {
      barFill.style.width = percent + '%';
    }

    el.classList.remove('is-hidden');
    el.classList.add('sc-pdp-stock-urgency--low-stock');
    return;
  }

  /*
    Normal low stock:
    Qty 5–14 = show softer selling-fast badge without bar.
  */
  if (qty >= criticalLowStockThreshold && qty < normalLowStockThreshold && cityLabel) {
    textEl.textContent = isArabic
      ? 'ينفد بسرعة في ' + cityLabel
      : 'Selling fast in ' + cityLabel;

    el.style.removeProperty('--sc-stock-bar-width');

    if (barFill) {
      barFill.style.width = '';
    }

    el.classList.remove('is-hidden');
    el.classList.add('sc-pdp-stock-urgency--selling-fast');
    return;
  }

  /*
    Healthy stock:
    Hide badge.
  */
  el.classList.add('is-hidden');
  textEl.textContent = '';
  el.style.removeProperty('--sc-stock-bar-width');

  if (barFill) {
    barFill.style.width = '';
  }
}

  function processPdpAvailability() {
    try {
      if (!window.CityState) return;

      var city = window.CityState.get();
      if (!city) return;

      document.querySelectorAll('[data-city-pdp-root]').forEach(function (root) {
        var map = parseMap(root);
        var cityVariant = findCityVariant(map, city);

        if (!cityVariant) return;

        var variantId = getVariantId(cityVariant);
        if (!variantId) return;

        var available = isVariantActuallyAvailable(cityVariant);
        var maxQty = getVariantMaxQty(cityVariant);

        setAttr(root, 'data-current-city-variant-id', variantId);
        setAttr(root, 'data-current-city-variant-available', available ? 'true' : 'false');
        setAttr(root, 'data-current-city-variant-max', String(maxQty));

        if (available) {
          removeClass(root, 'sc-city-pdp-soldout');
        } else {
          addClass(root, 'sc-city-pdp-soldout');
        }

        updatePdpForms(root, variantId, available, maxQty);
updateCustomPdpAtc(root, variantId, available, maxQty);
updateKallesPdpButtons(root, variantId, available);
updatePdpStockStatus(root, available);
updatePdpInventoryData(root, variantId, maxQty);
updatePdpStockUrgency(root, cityVariant, city);
updatePdpPickup(root, variantId);
      });
    } catch (e) {}
  }

  function evaluateVariantForCurrentCity(variantId) {
    if (!window.CityState) return { allowed: true };

    var city = window.CityState.get();
    if (!city) return { allowed: true };

    variantId = String(variantId || '');
    if (!variantId) return { allowed: true };

    var nodes = document.querySelectorAll('[data-city-availability]');
    var foundManagedVariant = false;

    for (var c = 0; c < nodes.length; c++) {
      var node = nodes[c];
      var map = parseMap(node);

      if (!map.length) continue;

      var cityVariant = findCityVariant(map, city);
      var cityVariantId = getVariantId(cityVariant);

      for (var i = 0; i < map.length; i++) {
        var itemVariantId = getVariantId(map[i]);

        if (String(itemVariantId) === variantId) {
          foundManagedVariant = true;

          if (cityVariantId && String(cityVariantId) === variantId) {
            return {
              allowed: isVariantActuallyAvailable(cityVariant),
              reason: 'city_variant_unavailable'
            };
          }

          return {
            allowed: false,
            reason: 'wrong_city_variant'
          };
        }
      }
    }

    return { allowed: !foundManagedVariant };
  }

  function getUnavailableMessage() {
    var isArabic = document.documentElement.getAttribute('dir') === 'rtl';

    return isArabic
      ? 'هذا المنتج غير متوفر في مدينتك المختارة. يرجى تغيير المدينة أو اختيار منتج آخر.'
      : 'This item is not available in your selected city. Please change your city or choose another item.';
  }

  function blockUnavailableVariant(event, variantId) {
    var result = evaluateVariantForCurrentCity(variantId);

    if (!result.allowed) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();

        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        }
      }

      alert(getUnavailableMessage());
      return true;
    }

    return false;
  }

  function extractVariantIdFromBody(body) {
    if (!body) return '';

    if (body instanceof FormData) {
      return body.get('id') || '';
    }

    if (body instanceof URLSearchParams) {
      return body.get('id') || '';
    }

    if (typeof body === 'string') {
      try {
        var params = new URLSearchParams(body);
        return params.get('id') || '';
      } catch (e) {
        return '';
      }
    }

    if (typeof body === 'object') {
      return body.id || '';
    }

    return '';
  }

  document.addEventListener(
    'click',
    function (event) {
      try {
        var trigger = event.target.closest(
          '.sc-pdp-sticky-mini-atc__add, [data-city-pdp-atc], .sc-card-atc, [data-city-add-to-cart], button[name="add"], [data-atc-selector], .t4s-pr-item-btn, .t4s-product-atc, .t4s-pr-addtocart, .t4s-sticky-atc__atc, .shopify-payment-button__button'
        );

        if (!trigger) return;

        var variantId =
          trigger.getAttribute('data-variant-id') ||
          '';

        if (!variantId) {
          var customWrap = trigger.closest('[data-sc-pdp-sticky-mini-atc], [data-city-pdp-custom-atc-wrap], .sc-pdp-sticky-mini-atc');
          if (customWrap) {
            variantId = customWrap.getAttribute('data-variant-id') || '';
          }
        }

        if (!variantId) {
          variantId = trigger.getAttribute('data-id') || '';
        }

        if (!variantId) {
          var form = trigger.closest('form');
          var input = form ? form.querySelector('input[name="id"], select[name="id"]') : null;

          if (input) {
            variantId = input.value;
          }
        }

        blockUnavailableVariant(event, variantId);
      } catch (e) {}
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      try {
        var form = event.target;

        if (!form || !form.matches('form[action*="/cart/add"]')) return;

        var input = form.querySelector('input[name="id"], select[name="id"]');
        if (!input) return;

        blockUnavailableVariant(event, input.value);
      } catch (e) {}
    },
    true
  );

  if (window.fetch && !window.__scCityFetchGuardInstalled) {
    window.__scCityFetchGuardInstalled = true;

    var nativeFetch = window.fetch;

    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
        var method = init && init.method ? String(init.method).toUpperCase() : 'GET';

        if (url.indexOf('/cart/add') !== -1 && method !== 'GET') {
          var variantId = extractVariantIdFromBody(init && init.body);

          if (variantId && !evaluateVariantForCurrentCity(variantId).allowed) {
            alert(getUnavailableMessage());

            if (window.Response) {
              return Promise.resolve(
                new Response(
                  JSON.stringify({
                    status: 422,
                    message: getUnavailableMessage(),
                    description: getUnavailableMessage()
                  }),
                  {
                    status: 422,
                    headers: { 'Content-Type': 'application/json' }
                  }
                )
              );
            }

            return Promise.reject(new Error(getUnavailableMessage()));
          }
        }
      } catch (e) {}

      return nativeFetch.apply(this, arguments);
    };
  }

  if (window.XMLHttpRequest && !window.__scCityXhrGuardInstalled) {
    window.__scCityXhrGuardInstalled = true;

    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._scCartAddUrl = url && String(url).indexOf('/cart/add') !== -1;
      this._scCartAddMethod = method ? String(method).toUpperCase() : 'GET';

      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (this._scCartAddUrl && this._scCartAddMethod !== 'GET') {
          var variantId = extractVariantIdFromBody(body);

          if (variantId && !evaluateVariantForCurrentCity(variantId).allowed) {
            alert(getUnavailableMessage());
            return;
          }
        }
      } catch (e) {}

      return nativeSend.apply(this, arguments);
    };
  }

  function observeAjaxCollectionProducts() {
  if (window.__scAjaxCollectionCityObserverReady) return;
  window.__scAjaxCollectionCityObserverReady = true;

  var observeTimer = null;

  function scheduleFullSync(delay) {
    window.clearTimeout(observeTimer);

    observeTimer = window.setTimeout(function () {
      runCityProductSync();

      /*
        Run again shortly after because Kalles can inject markup first,
        then initialize product buttons/prices after.
      */
      window.setTimeout(runCityProductSync, 250);
      window.setTimeout(runCityProductSync, 800);
    }, delay || 120);
  }

  function nodeHasCityProducts(node) {
    if (!node || node.nodeType !== 1) return false;

    if (
      node.matches &&
      (
        node.matches('[data-city-availability]') ||
        node.matches('.t4s-product') ||
        node.matches('.t4s-col-item')
      )
    ) {
      return true;
    }

    return !!(
      node.querySelector &&
      (
        node.querySelector('[data-city-availability]') ||
        node.querySelector('.t4s-product') ||
        node.querySelector('.t4s-col-item')
      )
    );
  }

  var observer = new MutationObserver(function (mutations) {
    var hasProductMutation = mutations.some(function (mutation) {
      if (!mutation.addedNodes || !mutation.addedNodes.length) return false;

      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return nodeHasCityProducts(node);
      });
    });

    if (hasProductMutation) {
      scheduleFullSync(120);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /*
    Kalles / theme AJAX events.
    Different Kalles actions can emit different events depending on section.
  */
  [
    'ajaxProduct:loaded',
    't4s:ajax:complete',
    't4s:collection:updated',
    't4s:products:loaded',
    't4s:loadmore:loaded',
    't4s:loadmore:complete',
    't4s:loadPrevious:loaded',
    't4s:loadPrevious:complete',
    'collection:updated',
    'products:loaded'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      scheduleFullSync(120);
    });
  });

  /*
    Back/forward cache restore:
    important when user opens PDP from page 2/3 and returns.
  */
  window.addEventListener('pageshow', function () {
    scheduleFullSync(180);
  });

  /*
    Fetch patch:
    catches collection AJAX requests even if the theme does not dispatch events.
  */
  if (window.fetch && !window.__scCityCollectionFetchRefreshInstalled) {
    window.__scCityCollectionFetchRefreshInstalled = true;

    var nativeFetchForCityRefresh = window.fetch;

    window.fetch = function () {
      var args = arguments;
      var url = '';

      try {
        url = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url ? args[0].url : '';
      } catch (e) {}

      return nativeFetchForCityRefresh.apply(this, args).then(function (response) {
        if (
          url.indexOf('/collections/') !== -1 ||
          url.indexOf('page=') !== -1 ||
          url.indexOf('section_id=') !== -1 ||
          url.indexOf('sections=') !== -1 ||
          url.indexOf('view=') !== -1
        ) {
          scheduleFullSync(250);
        }

        return response;
      });
    };
  }

  /*
    XHR patch:
    Kalles may use XMLHttpRequest for Load more / Load previous.
  */
  if (window.XMLHttpRequest && !window.__scCityCollectionXhrRefreshInstalled) {
    window.__scCityCollectionXhrRefreshInstalled = true;

    var nativeXhrOpenForCityRefresh = XMLHttpRequest.prototype.open;
    var nativeXhrSendForCityRefresh = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__scCityRefreshUrl = url || '';
      return nativeXhrOpenForCityRefresh.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var xhr = this;

      try {
        xhr.addEventListener('loadend', function () {
          var url = String(xhr.__scCityRefreshUrl || '');

          if (
            url.indexOf('/collections/') !== -1 ||
            url.indexOf('page=') !== -1 ||
            url.indexOf('section_id=') !== -1 ||
            url.indexOf('sections=') !== -1 ||
            url.indexOf('view=') !== -1
          ) {
            scheduleFullSync(250);
          }
        });
      } catch (e) {}

      return nativeXhrSendForCityRefresh.apply(this, arguments);
    };
  }
}
  function runCityProductSync() {
    processCards();
    processPdpAvailability();
  }

  function scheduleCityProductSync() {
    if (citySyncTimer) {
      window.clearTimeout(citySyncTimer);
    }

    citySyncTimer = window.setTimeout(function () {
      runCityProductSync();
    }, 80);
  }

  function observePdpCityChanges() {
    var root = document.querySelector('[data-city-pdp-root]');
    if (!root || root.dataset.cityObserverReady === 'true') return;

    root.dataset.cityObserverReady = 'true';

    function createObserver(target) {
      if (!target || target.dataset.cityObserverAttached === 'true') return;

      target.dataset.cityObserverAttached = 'true';

      var observer = new MutationObserver(function (mutations) {
        var shouldRun = mutations.some(function (mutation) {
          if (mutation.type === 'attributes') {
            return ['class', 'disabled', 'aria-disabled', 'data-variant-id', 'value', 'style', 'data-state'].indexOf(mutation.attributeName) !== -1;
          }

          if (mutation.type === 'childList') {
            return true;
          }

          return false;
        });

        if (shouldRun) {
          scheduleCityProductSync();
        }
      });

      observer.observe(target, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'disabled', 'aria-disabled', 'data-variant-id', 'value', 'style', 'data-state']
      });
    }

    createObserver(root);

    document.querySelectorAll('[data-sc-pdp-sticky-mini-atc], [data-city-pdp-custom-atc-wrap], .sc-pdp-sticky-mini-atc').forEach(function (wrap) {
      createObserver(wrap);
    });
  }

  if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    runCityProductSync();
    observePdpCityChanges();
    observeAjaxCollectionProducts();
  });
} else {
  runCityProductSync();
  observePdpCityChanges();
  observeAjaxCollectionProducts();
}

  window.addEventListener('load', function () {
  runCityProductSync();
  observePdpCityChanges();
  observeAjaxCollectionProducts();

  window.setTimeout(runCityProductSync, 500);

  if (!document.querySelector('[data-city-pdp-root]')) {
    window.setTimeout(runCityProductSync, 1200);
  }
});

  document.addEventListener('shopify:section:load', function () {
  runCityProductSync();
  observePdpCityChanges();
  observeAjaxCollectionProducts();
});

  document.addEventListener('city:changed', function () {
    window.location.reload();
  });
})();